import { focusOutline } from '@apia/theme';
import { ThemeUICSSObject } from '@apia/theme';

export const styles: ThemeUICSSObject = {
  '&:focus-within': {
    '.listbox__list': {
      outline: 'none',
    },

    '.focused': focusOutline,

    '&.withSearchbox': {
      '.focused': {
        outline: '1px solid',
        outlineColor: 'palette.border.field',
        outlineOffset: 0,
      },
      '.listbox__searchbox': focusOutline,
    },
  },

  '.listbox__list': {
    listStyle: 'none',
    m: 0,
    p: 0,
  },

  '&.withSearchbox': {
    '.listbox__list': {
      maxHeight: 'calc(100vh - 80px)',
      overflow: 'auto',
    },
  },

  '.listbox__row': {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',

    '&:hover': (theme) => {
      return {
        ...theme.palette.getOneState(
          { backgroundColor: 'palette.background.paper' },
          'hover',
        ),
        cursor: 'pointer',
      };
    },
  },
};
